export class MappedAreaModel {
  constructor(
    public planSvg: string,
    public name: string,
    public isExported: boolean
  ) {}
}
